import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {
    MxButtonModule,
    MxDynamicFieldsModule,
    MxFormModule,
    MxInfoTooltipModule,
    MxMaterialModule,
    MxSharedModule
} from 'mx-core';
import {MxForgotPasswordComponent} from "./mx-forgot-password/mx-forgot-password.component";

@NgModule({
    imports: [
        CommonModule,
        MxMaterialModule,
        ReactiveFormsModule,
        MxButtonModule,
        TranslateModule,
        MxDynamicFieldsModule,
        MxFormModule,
        MxInfoTooltipModule,
        MxSharedModule,
    ],
    exports: [MxForgotPasswordComponent],
    declarations: [MxForgotPasswordComponent]
})
export class MxAuthenticationModule {
}
